export const ArrowDownLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10V25H22" stroke="currentColor" stroke-width="2"/>
<path d="M25.2897 6.71036L7 25" stroke="currentColor" stroke-width="2"/>
</svg>`;
